import { Component, Input, OnDestroy } from '@angular/core';
import { AppState } from '../../core/app-state';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { PathTestService, BuildingService, PointService, PathWaypointService, UserService } from '../../core/services';
import { PathTestDoc } from '../../core/schema/path-test-schema';
import { AppTab } from '../../core/app-tab';
import { getValueFromPath } from '../../shared/directives/list-view.directive';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-path-list',
  templateUrl: './path-list.component.html',
  styleUrls: ['./path-list.component.scss']
})
export class PathListComponent extends FesBaseComponent implements OnDestroy {

  @Input() set tabConfig(tabConfig: AppTab) {
    tabConfig.setSelected = this.onTabSelected
  }

  isLoading: boolean = false;
  paths: PathTestDoc[] = []
  activeStage: string

  constructor(
    public appState: AppState,
    private pathTestService: PathTestService,
    private buildingService: BuildingService,
    private pointService: PointService,
    private wayPointService: PathWaypointService,
    private userService: UserService,
    private datePipe: DatePipe
  ) {
    super(appState)
    this.activeStage = appState.activeStage
  }

  initialize() {
    this.isLoading = true
    this.pathTestService.doWhenReady(() => {
      const pathQuery = this.pathTestService.rxCollection.find()
      this.subscribe(
        pathQuery.$,
        async paths => {
          try {
            await this.updatePathList(paths)
          } catch (error) {
            this.pathTestService.publishError(error, this)
          } finally {
            this.isLoading = false
          }
        },
        error => {
          this.isLoading = false
          this.pathTestService.publishError(error, this)
        }
      )
    })
  }

  onTabSelected = (bSelected: boolean) => {
    console.log('path-list tab selected: ' + bSelected)
    if (bSelected) {
      this.initialize()
    } else {
      this.unsubscribe()
    }
  }

  ngOnDestroy(): void {
    this.destroy()
  }

  async updatePathList(paths: PathTestDoc[]) {
    try {
      for (let i = 0; i < paths.length; i++) {
        const path = paths[i]
        let pathObj = (path as any)
        if (pathObj.buildingName === undefined) {
          path.get$('buildingId').subscribe(buildingId => {
            this.buildingService.rxCollection.findOne(path.buildingId).exec().then(buildingDoc => {
              pathObj.buildingName = buildingDoc.commonName
            })
          })
        }
        if (pathObj.floor === undefined) {
          path.get$('pathId').subscribe(pathId => {
            console.log("Testing: " + pathId)
            this.wayPointService.rxCollection.findOne().where({
              $and: [{ "pathId": path.pathId }, { "pointId": { $ne: "" } }]
            }).exec().then(wayPointDoc => {
              this.pointService.getById(wayPointDoc.pointId).then(pointDoc => {
                pathObj.floor = pointDoc?.floorName
              })
            })
          })
        }
        if (pathObj.scheduler === undefined || pathObj.tester === undefined) {
          path.get$("assignments.scheduleUserId").subscribe(scheduleUserId => {
            if (scheduleUserId != null) {
              this.userService.rxCollection.findOne(scheduleUserId).exec().then(user => {
                if (!user) {
                  console.warn('No scheduler found for path ' + path._id + ' with userId: ' + scheduleUserId)
                  pathObj.scheduler = ''
                } else {
                  pathObj.scheduler = user.firstName + ' ' + user.lastName
                }
              })
            }
          })
          path.get$('assignments.testUserId').subscribe(testUserId => {
            if (testUserId != null && testUserId != "") {
              this.userService.rxCollection.findOne(testUserId).exec().then(user => {
                if (!user) {
                  console.warn('No tester found for path ' + path._id + ' with userId: ' + testUserId)
                  pathObj.tester = ''
                } else {
                  pathObj.tester = user.firstName + ' ' + user.lastName
                }
              })
            }
          })
        }
      }
      this.paths = paths
    } catch (error) {
      this.pathTestService.publishError(error, this)
    } finally {
    }
  }


  newPathTest() {
    // TODO
    console.log('newPathTest() not implemented')
  }

  editPathTest(pathTest : PathTestDoc) {
    //TODO
    console.log('editPathTest() not implemented')
  }

  deletePathTest(pathTest : PathTestDoc) {
    //TODO
    console.log('deletePathTest() not implemented')
  }
  
  // for sort and filtering of dates in format MM/dd
  monthDayResolver = ( path : PathTestDoc, fieldName : string ) : string => {
    if ( !path ) {
      return ''
    }
    const dateString = getValueFromPath(path,fieldName)
    const monthDay =  this.datePipe.transform(dateString,'MM/dd')
    return monthDay
  }
}
